import React, { useRef } from "react";
import emailjs from "emailjs-com";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_8n85atj",
        "template_vvnzmhn",
        form.current,
        "user_cCJkUcAJv4WSpc9QVPDfh"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <section
      className="text-gray-600 body-font py-4 lg:py-8  bg-gray-800 "
      id="contact"
    >
      <div className="text-center pb-2">
        <h1 className="font-bold text-xl md:text-2xl lg:text-3xl font-heading text-white">
          Contact Me
        </h1>
      </div>
      <div className="container max-w-full lg:px-12 mx-auto flex px-4  md:flex-row  flex-col items-center">
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-48  text-white">
          <h2 className="text-lg text-red-400">Get In Touch</h2>
          <span>
            I am available to work on your projects and bring your ideas in real
            life
          </span>
          <div className="flex py-4 items-center ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 p-2 bg-red-400 rounded-full text-gray-800"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                clipRule="evenodd"
              />
            </svg>
            <span className="px-4">Dar es Salaam, Tanzania</span>
          </div>

          <div className="flex py-4 items-center ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 p-2 bg-red-400 rounded-full text-gray-800"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
            </svg>
            <span className="px-4">+255 675 117 574</span>
          </div>
        </div>
        <div className="lg:w-1/3 md:w-1/2 bg-gray-900 rounded-lg p-6 flex flex-col md:ml-auto w-full mt-10 md:mt-0  shadow-lg">
          <h2 className="text-white text-lg mb-1 font-medium title-font">
            Contact Me
          </h2>
          <form ref={form} onSubmit={sendEmail}>
            <div className="relative mb-2">
              <label
                htmlFor="name"
                className=" flex leading-7 text-sm text-white"
              >
                Name
              </label>
              <input
                type="name"
                id="name"
                name="user_name"
                className="w-full bg-gray-800 rounded focus:ring-2  focus:ring-red-500 text-base outline-none text-white py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
              />
            </div>
            <div className="relative mb-2">
              <label
                htmlFor="email"
                className="flex leading-7 text-sm text-white"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="user_email"
                className="w-full bg-gray-800 rounded focus:ring-2 focus:ring-red-500 text-base outline-none text-white py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
              />
            </div>
            <div className="relative mb-2">
              <label
                htmlFor="subject"
                className="flex leading-7 text-sm text-white"
              >
                Subject
              </label>
              <input
                type="subject"
                id="subject"
                name="user_subject"
                className="w-full bg-gray-800 rounded focus:ring-2 focus:ring-red-500 text-base outline-none text-white py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
              />
            </div>
            <div className="relative mb-2">
              <label
                htmlFor="message"
                className="flex leading-7 text-sm text-white"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                className="w-full bg-gray-800 rounded focus:ring-2 focus:ring-red-500 h-32 text-base outline-none text-white py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
              ></textarea>
            </div>
            <button
              className="text-white bg-red-500 border-0 py-2 px-6 focus:outline-none hover:bg-red-600 rounded text-lg"
              type="submit"
            >
              Button
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
